import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';

import Bookings from '../views/pages/Bookings';
import Dashboard from '../views/pages/Dashboard/Dashboard';
import Explore from '../views/pages/Explore';
import Customers from '../views/pages/customers';
import PropertyDetails from '../views/pages/Property';
import Login from '../views/authentication/auth/Login';
import Register from '../views/authentication/auth/Register';
import GuestGuard from '../guards/authGuard/GuestGaurd';
import AuthGuard from '../guards/authGuard/AuthGuard';
import Payments from '../views/pages/Property/Payments';
import PaymentSuccess from '../components/PaymentSuccess';
import ForgotPassword from '../views/authentication/auth/ForgotPassword';
import ResetPassword from '../views/authentication/auth/ResetPassword';
import Enquiries from '../views/pages/Enquiry';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
// const SamplePage = Loadable(lazy(() => import('../views/sample-page/SamplePage')))
const Error = Loadable(lazy(() => import('../views/authentication/Error')));

const Router = [
  {
    path: '/',
    element: (<AuthGuard>
    <FullLayout />
  </AuthGuard>),
    children: [
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/explore', exact: true, element: <Explore /> },
      { path: '/property/:id', exact: true, element: <PropertyDetails /> },
      { path: '/property/:id/payments/:id', exact: true, element: <Payments /> },
      { path: '/property/:id/payments/:id/success', exact: true, element: <PaymentSuccess /> },
      { path: '/enquiry', exact: true, element: <Enquiries /> },
      { path: '/students', exact: true, element: <Customers /> },
      { path: '/bookings', exact: true, element: <Bookings /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: (
      <GuestGuard>
        <BlankLayout />
      </GuestGuard>
    ),
    children: [
      { path: '404', element: <Error /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      {
        path: 'reset-password',
        element: <ResetPassword />
      },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/',
    element: (
      <GuestGuard>
        <BlankLayout />
      </GuestGuard>
    ),
    children: [
      { path: '/payments/:id', element: <Payments /> },
      { path: '/payments/:id/success', element: <PaymentSuccess /> },

    ],
  },
];

export default Router;
